// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__3vs8D","thaihealth":"footer_thaihealth__38_ni","sorsorsor":"footer_sorsorsor__2Xse1"};